module.exports = __webpack_public_path__ + "static/media/General.bdcb8f15.jpg";